// Quote Modal Functions
function openQuoteModal() {
  const overlay = document.querySelector('[data-quote-modal-overlay]');
  const modal = document.querySelector('[data-quote-modal]');
  
  if (!overlay || !modal) return;

  modal.classList.add('is-visible');
  overlay.classList.add('is-visible');
  
  // Prevent body scroll
  document.body.style.overflow = 'hidden';
  
  // Focus on first input
  const firstInput = modal.querySelector('.quote-modal__input');
  if (firstInput) {
    setTimeout(() => firstInput.focus(), 100);
  }
}

function closeQuoteModal() {
  const overlay = document.querySelector('[data-quote-modal-overlay]');
  const modal = document.querySelector('[data-quote-modal]');
  
  if (!overlay || !modal) return;
  
  modal.classList.remove('is-visible');
  overlay.classList.remove('is-visible');
  
  // Restore body scroll
  document.body.style.overflow = '';
  
  // Reset form
  const form = modal.querySelector('[data-quote-form]');
  if (form) {
    form.reset();
    // Hide success/error messages
    const errorMessage = modal.querySelector('[data-quote-error]');
    const successMessage = modal.querySelector('[data-quote-success]');
    if (errorMessage) errorMessage.hidden = true;
    if (successMessage) successMessage.hidden = true;
  }
}

// Initialize modal triggers
function initQuoteModal() {
  // Add click handlers to all quote modal triggers
  const triggers = document.querySelectorAll('[data-quote-modal-trigger]');
  triggers.forEach(trigger => {
    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      openQuoteModal();
    });
  });
  
  // Add click handler to close button
  const closeButton = document.querySelector('[data-quote-modal-close]');
  if (closeButton) {
    closeButton.addEventListener('click', (e) => {
      e.preventDefault();
      closeQuoteModal();
    });
  }
  
  // Close on overlay click
  const overlay = document.querySelector('[data-quote-modal-overlay]');
  if (overlay) {
    overlay.addEventListener('click', (e) => {
      // Only close if clicking directly on overlay, not on modal content
      if (e.target === overlay) {
        closeQuoteModal();
      }
    });
  }
  
  // Close when clicking outside modal content (on the modal wrapper)
  const modal = document.querySelector('[data-quote-modal]');
  if (modal) {
    modal.addEventListener('click', (e) => {
      // Close if clicking outside the content box itself
      const content = modal.querySelector('.quote-modal__content');
      if (content && !content.contains(e.target)) {
        closeQuoteModal();
      }
    });
  }
  
  // Close on Escape key
  document.addEventListener('keydown', function(event) {
    if (event.key === 'Escape') {
      const modal = document.querySelector('[data-quote-modal]');
      if (modal && modal.classList.contains('is-visible')) {
        closeQuoteModal();
      }
    }
  });

  // Handle form submission
  const form = document.querySelector('[data-quote-form]');
  if (form) {
    form.addEventListener('submit', handleQuoteFormSubmit);
  }
}

// Handle quote form submission
async function handleQuoteFormSubmit(e) {
  e.preventDefault();
  
  const form = e.target;
  const submitButton = form.querySelector('[data-quote-submit]');
  const submitText = form.querySelector('[data-quote-submit-text]');
  const submitLoading = form.querySelector('[data-quote-submit-loading]');
  const errorMessage = form.querySelector('[data-quote-error]');
  const errorText = form.querySelector('.quote-modal__error-text');
  const successMessage = form.querySelector('[data-quote-success]');
  
  // Hide previous messages
  if (errorMessage) errorMessage.hidden = true;
  if (successMessage) successMessage.hidden = true;
  
  // Disable submit button and show loading
  if (submitButton) {
    submitButton.disabled = true;
  }
  if (submitText) submitText.classList.add('hidden');
  if (submitLoading) submitLoading.classList.remove('hidden');
  
  try {
    const formData = new FormData(form);
    
    // Submit form
    const response = await fetch(form.action, {
      method: 'POST',
      body: formData,
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      }
    });
    
    if (response.ok) {
      // Show success message
      if (successMessage) {
        successMessage.hidden = false;
      }
      
      // Reset form
      form.reset();
      
      // Close modal after a delay
      setTimeout(() => {
        closeQuoteModal();
      }, 2000);
    } else {
      throw new Error('Form submission failed');
    }
  } catch (error) {
    console.error('Quote form error:', error);
    
    // Show error message
    if (errorMessage && errorText) {
      errorText.textContent = error.message || 'An error occurred. Please try again.';
      errorMessage.hidden = false;
    }
  } finally {
    // Re-enable submit button and hide loading
    if (submitButton) {
      submitButton.disabled = false;
    }
    if (submitText) submitText.classList.remove('hidden');
    if (submitLoading) submitLoading.classList.add('hidden');
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initQuoteModal);
} else {
  initQuoteModal();
}

// Make functions globally available
window.openQuoteModal = openQuoteModal;
window.closeQuoteModal = closeQuoteModal;
